import React, { useState, useContext } from "react";
import AddStudents from '../components/Students/AddStudents'
import AuthContext from "../AuthContext";
import AllStudents from '../components/Students/AllStudents'
import UpdateStudent from '../components/Students/UpdateStudent'
import Attendance from '../components/Students/Attendance'
import { useParams,useLocation } from "react-router-dom";
import Placement from '../components/Students/Placement'
import BatchStudent from '../components/BatchStudent/AllBatchStudents'
import BreadCrumbs from '../components/Breadcrumbs'
function Inventory() {
  const [showProductModal, setShowProductModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const[showAttendanceeModal,setShowAttendanceModal]=useState(false)
  const [showPlacementModal,setShowPlacementModal]=useState(false)
  const [updateProduct, setUpdateProduct] = useState([]);
  const[placement,setPlacement]=useState([])
  const[attendance,setAttendence]=useState([])
  const location=useLocation()
  const {id}=location.state||{}
  const [updatePage, setUpdatePage] = useState(true);
  const bstudent=true
  const authContext = useContext(AuthContext);

  // Modal for Product ADD
  const addProductModalSetting = () => {
    setShowProductModal(!showProductModal);
  };

  // Modal for Product UPDATE
  const updateProductModalSetting = (selectedProductData) => {
    setUpdateProduct(selectedProductData);
    setShowUpdateModal(!showUpdateModal);
  };
  const updateAttendanceSetting = (selectedProductData) => {
    setAttendence(selectedProductData);
    setShowAttendanceModal(!showAttendanceeModal)
  };
  const updatePlacementSetting = (selectedProductData) => {
    setPlacement(selectedProductData);
    setShowPlacementModal(!showPlacementModal)
  };


  // Handle Page Update
  const handlePageUpdate = () => {
    setUpdatePage(!updatePage);
  };
  return (

<div className="col-span-12 lg:col-span-10  flex justify-center">
      <div className=" flex flex-col gap-5 w-11/12">
      <BreadCrumbs/>
        {showProductModal && (authContext.userType!=='Accounts') &&  (
          <AddStudents
          bstudent={bstudent}
          stbn={id}
            addProductModalSetting={addProductModalSetting}
            handlePageUpdate={handlePageUpdate}
          />
        )}
        {showUpdateModal && (
          <UpdateStudent
          tbn={id}
            updateProductData={updateProduct}
            handlePageUpdate={handlePageUpdate}
            updateModalSetting={updateProductModalSetting}
          />
        )}
          {showAttendanceeModal&& (
          <Attendance
            updateAttendanceData={attendance}
            handlePageUpdate={handlePageUpdate}
            updateAttendanceSetting={updateAttendanceSetting}
          />
        )}
        {
          showPlacementModal&& (
          <Placement
          handlePageUpdate={handlePageUpdate}
            updatePlacementData={placement}
            updateModalSetting={updatePlacementSetting}
          />
        )}
        {/* Table  */}
        <div className="overflow-x-auto  rounded-t-md bg-white border-gray-200 ">
          <div className="flex justify-between pt-5 pb-3 px-3">
            <div className="flex gap-4 justify-center items-center ">
              <span className="font-bold text-gray-700">Students</span>
              
            </div>
            <div className="flex gap-4">
             {authContext.userType!=='Accounts' &&
              <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-medium p-2 text-sm  rounded-sm shadow-blue-700"
              onClick={addProductModalSetting}
            >
              {/* <Link to="/inventory/add-product">Add Product</Link> */}
              Add New Student
            </button>
             }
            </div>
            
          </div>
          <BatchStudent
          updateProductModalSetting={updateProductModalSetting} 
          updateAttendanceSetting={updateAttendanceSetting}
          updatePlacementSetting={updatePlacementSetting} 
          id={id}
          handlePageUpdate={handlePageUpdate}/>

        </div>

      </div>
      </div>
  );
}

export default Inventory;
